import { GAME_TYPE } from '../constants'
import './DragDropGameHeading.scss'
import React from 'react'

const gameTypeDefaultHeadingMapper = {
  [GAME_TYPE.PAIRS]: {
    headline: 'Match the pairs',
    description: 'Drag and drop the items to match the pairs',
  },
  [GAME_TYPE.ORDER]: {
    headline: 'Order the items',
    description: 'Drag and drop the items to order them',
  },
  [GAME_TYPE.RANKING]: {
    headline: 'Rank the items',
    description: 'Drag and drop the items to rank them',
  },
}

export const DragDropGameHeading = ({
  gameType,
  startTitle,
  startDescription,
}) => {
  const headline = `${
    startTitle || gameTypeDefaultHeadingMapper[gameType].headline
  }`
  const description =
    startDescription || gameTypeDefaultHeadingMapper[gameType].description

  return (
    <div className="heading_wrapper">
      <div>
        <h2
          className="instruction_title"
          dangerouslySetInnerHTML={{ __html: headline }}
        />
        <h3
          className="instruction_description"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </div>
    </div>
  )
}
